var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99337 0.333344C3.31337 0.333344 0.333374 3.32001 0.333374 7.00001C0.333374 10.68 3.31337 13.6667 6.99337 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7.00001C13.6667 3.32001 10.68 0.333344 6.99337 0.333344ZM4.66671 4.33334C5.22004 4.33334 5.66671 4.78001 5.66671 5.33334C5.66671 5.88668 5.22004 6.33334 4.66671 6.33334C4.11337 6.33334 3.66671 5.88668 3.66671 5.33334C3.66671 4.78001 4.11337 4.33334 4.66671 4.33334ZM10.14 8.81334C9.53337 10.1133 8.36004 11 7.00004 11C5.64004 11 4.46671 10.1133 3.86004 8.81334C3.75337 8.59334 3.91337 8.33334 4.16004 8.33334H9.84004C10.0867 8.33334 10.2467 8.59334 10.14 8.81334ZM9.33337 6.33334C8.78004 6.33334 8.33337 5.88668 8.33337 5.33334C8.33337 4.78001 8.78004 4.33334 9.33337 4.33334C9.88671 4.33334 10.3334 4.78001 10.3334 5.33334C10.3334 5.88668 9.88671 6.33334 9.33337 6.33334Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileGrey);
export default __webpack_public_path__ + "static/media/smileGrey.63a62baa.svg";
export { ForwardRef as ReactComponent };